import React, { ReactNode } from 'react';

import useChannelUpdateEventListener from '../hooks/useChannelUpdateEventListener';
import useMessageCreateEventListener from '../hooks/useMessageCreateEventListener';
import useMessageReadEventListener from '../hooks/useMessageReadEventListener';
import useMessageUpdateEventListener from '../hooks/useMessageUpdateEventListener';
import useReconnectedEventListener from '../hooks/useReconnectedEventListener';
import useResetChatOnCompanySwitch from '../hooks/useResetChatOnCompanySwitch';

type Props = {
  children: ReactNode;
};

export default function WSEventListenerWrapper({ children }: Props) {
  useMessageReadEventListener();
  useMessageUpdateEventListener();
  useChannelUpdateEventListener();
  useMessageCreateEventListener();
  useReconnectedEventListener();
  useResetChatOnCompanySwitch();

  return <>{children}</>;
}
